(function() {
    var ClosedDatesField= function($el) {
        this.$el = $el
        this.$form = this.$el.closest('form')
        this.$select = this.$form.find('select')
        this.$startDate = this.$form.find(this.$el.data('startDate'))
        this.$endDate = this.$form.find(this.$el.data('endDate'))
        this.$startDateTrigger = this.$form.find(this.$el.data('startDateTrigger'))
        this.$endDateTrigger = this.$form.find(this.$el.data('endDateTrigger'))
        this.closedDates = this.$el.data('closedDates')
        this.endpoint = this.$el.data('endpoint')
        this.options = []

        this.init()
    
        return this
    }

    ClosedDatesField.prototype.init = function () {
        this.bind()
        this.getOptions()
    }

    ClosedDatesField.prototype.bind = function () {
        this.$startDateTrigger.on('change', this.getOptions.bind(this))
        this.$endDateTrigger.on('change', this.getOptions.bind(this))
        this.$select.on('change', this.getClosedDates.bind(this))
    }

    ClosedDatesField.prototype.error = function () {
        this.hide()
    }

    ClosedDatesField.prototype.getClosedDates = function () {
       this.closedDates = this.$select.val()
    }

    ClosedDatesField.prototype.hide = function () {
        this.$el.hide()
    }

    ClosedDatesField.prototype.getOptions = function () {
        $.get(this.endpoint, {
            start_date: this.$startDate.val(),
            end_date: this.$endDate.val(),
        })
        .done(this.setOptions.bind(this))
        .fail(this.error.bind(this))
    }

    ClosedDatesField.prototype.setOptions = function (response) {
        this.options = response.data
        this.render()
    }

    ClosedDatesField.prototype.render = function () {
        this.$select.html('')

        if (this.options.length == 0) {
            this.hide()
            return
        }

        for (var i = 0; i < this.options.length; i++) {
            this.$select.append($('<option/>', this.options[i]));
        }

        this.$select.selectpicker('val', this.closedDates)
        this.$select.selectpicker('refresh')

        this.$el.fadeIn()
    }

    $('.closed-dates').each(function () {
        new ClosedDatesField($(this))
    })
})()
